// "Doručit do" helpers: days left until the contractual delivery deadline of a machine.

const DAY_MS = 24 * 60 * 60 * 1000;
export const DEADLINE_WARNING_DAYS = 14;

const dateOnly = (value) => (value ? String(value).slice(0, 10) : null);

// { state: 'done' | 'overdue' | 'soon' | 'ok' | 'none', days, label, color, bg }
export function deadlineInfo(deadline, deliveredAt, today = new Date()) {
  const due = dateOnly(deadline);
  if (deliveredAt) return { state: "done", days: null, label: "doručeno", color: "#2E7D32", bg: "#E8F5E9" };
  if (!due) return { state: "none", days: null, label: "termín nezadán", color: "#777", bg: "#F5F5F5" };
  const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const [y, m, d] = due.split("-").map(Number);
  const days = Math.round((Date.UTC(y, m - 1, d) - todayUtc) / DAY_MS);
  if (days < 0) return { state: "overdue", days, label: `po termínu ${-days} ${dayWord(-days)}`, color: "#B71C1C", bg: "#FFEBEE" };
  if (days === 0) return { state: "soon", days, label: "dnes je poslední den", color: "#B71C1C", bg: "#FFEBEE" };
  if (days <= DEADLINE_WARNING_DAYS) return { state: "soon", days, label: `zbývá ${days} ${dayWord(days)}`, color: "#8D5300", bg: "#FFF3E0" };
  return { state: "ok", days, label: `zbývá ${days} ${dayWord(days)}`, color: "#1565C0", bg: "#E3F2FD" };
}

function dayWord(n) {
  if (n === 1) return "den";
  if (n >= 2 && n <= 4) return "dny";
  return "dní";
}

export const formatCzDate = (value) => {
  const iso = dateOnly(value);
  if (!iso) return "–";
  const [y, m, d] = iso.split("-");
  return `${Number(d)}. ${Number(m)}. ${y}`;
};
